export class AuthorizationConstants {
  public static readonly bronze = 'Bronze'
  public static readonly silver = 'Silver'
  public static readonly gold = 'Gold'

  public static readonly admin = 'Admin'
  public static readonly superAdmin = 'SuperAdmin'
}
